import { Fragment, useEffect, useContext, useRef, useState } from "react";
import { validateEgyptianPhoneNumber } from "../../../../helpers/Validation";
import stylesRequestData from "../../UnifiedTaxDeclarationRequestData/index.module.css";
import SearchSelectElement from "../../../../shared/form/SearchSelectElement";
import InputElement from "../../../../shared/form/InputElement";
import UnifiedTaxDeclarationContext from "../../../../contexts/UnifiedTaxDeclarationProvider";
import { post } from "../../../../adapters/xhr/api";
import { useLocation } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isValidPhoneNumber } from "libphonenumber-js";

const TaxPayerForm = ({
  generateOptions,
  unitOwnerTypeErrorMessage,
  taxpayerTypes,
  error_new_user,
  nationalitesOptions,
  validateRequired,
  setError,
  setValidFields,
  setUploadFileError,
  handleTypeOneChange,
  handleTypeTwoChange,
  setTempFiles,
}) => {
  const location = useLocation();
  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const {
    declarationRequest,
    updateDeclarationTaxpayer,
    setDeclarationRequest,
    phoneError,
    setPhoneError,
  } = unifiedTaxDeclarationContext;
  const nationalIdFileInputRef = useRef();
  const passportNumFileInputRef = useRef();
  const commercialRegistrationNumberInputRef = useRef();
  const taxNumberFileInputRef = useRef();
  const otherEntityFileInputRef = useRef();
  // const [phoneError, setPhoneError] = useState("");

  const handleNationalityChange = () => {
    setPhoneError(null);
    setError("national_id", "");
    setError("national_id_attachment", "");
    setError("passport_number", "");
    setError("passport_attachment", "");
    setValidFields((prev) => ({
      ...prev,
      national_id: false,
      national_id_attachment: false,
      passport_number: false,
      passport_attachment: false,
    }));
    setDeclarationRequest((prev) => ({
      ...prev,
      taxpayer: {
        ...prev.taxpayer,
        national_id: null,
        passport_number: null,
        national_id_attachment: null,
        passport_attachment: null,
        phone: "20",
        country_code: "eg",
        dial_code: "20",
      },
    }));
    if (nationalIdFileInputRef?.current) {
      nationalIdFileInputRef.current.value = null;
    }
    if (passportNumFileInputRef?.current) {
      passportNumFileInputRef.current.value = null;
    }
  };

  const handleChangeTaxPayer = (pc, c, key, value) => {
    setError(key, "");
    setValidFields((prev) => ({
      ...prev,
      [key]: true,
    }));

    updateDeclarationTaxpayer(key, value);

    if (key === "nationality_id") {
      handleNationalityChange();
      setPhoneError(null);
      setError("phone", "");
    }

    if (key === "type_id") {
      handleTypeOneChange();
      handleTypeTwoChange();
      setPhoneError(null);
      setError("phone", "");
    }
  };

  const handleChangeTaxPayerFile = async (pc, c, key, value) => {
    try {
      const data = new FormData();
      data.append(`label`, key);
      data.append(`file`, value);

      if (value) {
        const response = await post(
          "api/declaration-system/declarations/upload-attachments",
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          },
          data,
        );

        updateDeclarationTaxpayer(key, response?.data?.data);
        setError(key, "");
        setUploadFileError(null);
        if (location?.pathname?.includes("add") && !declarationRequest?.id) {
          setTempFiles((prev) => [...prev, response?.data?.data?.path]);
        }
      }
    } catch (error) {
      if (error.status === 422) {
        setValidFields((prev) => ({
          ...prev,
          key: false,
        }));
        // setDeclarationRequest((prev) => ({
        //   ...prev,
        //   [key]: null,
        // }));
        updateDeclarationTaxpayer(key, null);
        window.scrollTo(0, 0);
        setError(key, "يجب رفع الصورة");
        setUploadFileError(error?.response?.data?.errors?.file);
      }
    }
  };

  useEffect(() => {
    if (
      parseInt(declarationRequest?.taxpayer?.type_id) === 2 &&
      (declarationRequest?.taxpayer?.commercial_register == null ||
        declarationRequest?.taxpayer?.commercial_register == "")
    ) {
      setError("commercial_register", "");
      setError("commercial_register_attachment", "");
      setValidFields((prev) => ({
        ...prev,
        commercial_register_attachment: false,
      }));
      handleChangeTaxPayer("", "", "commercial_register_attachment", null);

      if (commercialRegistrationNumberInputRef?.current) {
        commercialRegistrationNumberInputRef.current.value = null;
      }

      // commercialRegistrationNumberInputRef.current.value = null;
    }
  }, [
    declarationRequest?.taxpayer?.type_id,
    declarationRequest?.taxpayer?.commercial_register,
  ]);

  useEffect(() => {
    if (
      parseInt(declarationRequest?.taxpayer?.type_id) === 2 &&
      (declarationRequest?.taxpayer?.tax_card_number == null ||
        declarationRequest?.taxpayer?.tax_card_number == "")
    ) {
      setError("tax_card_number", "");
      setError("tax_card_attachment", "");
      setValidFields((prev) => ({
        ...prev,
        tax_card_attachment: false,
      }));

      handleChangeTaxPayer("", "", "tax_card_attachment", null);

      if (taxNumberFileInputRef?.current) {
        taxNumberFileInputRef.current.value = null;
      }

      // taxNumberFileInputRef.current.value = null;
    }
  }, [
    declarationRequest?.taxpayer?.type_id,
    declarationRequest?.taxpayer?.tax_card_number,
  ]);

  useEffect(() => {
    if (
      parseInt(declarationRequest?.taxpayer?.type_id) === 2 &&
      (declarationRequest?.taxpayer?.other_attachment_name == null ||
        declarationRequest?.taxpayer?.other_attachment_name == "")
    ) {
      setError("other_attachment_name", "");
      setError("other_attachment", "");
      setValidFields((prev) => ({
        ...prev,
        other_attachment: false,
        other_attachment_name: false,
      }));

      setDeclarationRequest((prev) => ({
        ...prev,
        taxpayer: {
          ...prev.taxpayer,
          other_attachment: null,
          other_attachment_name: null,
        },
      }));

      if (otherEntityFileInputRef?.current) {
        otherEntityFileInputRef.current.value = null;
      }
    }
  }, [
    declarationRequest?.taxpayer?.type_id,
    declarationRequest?.taxpayer?.other_attachment_name,
  ]);

  useEffect(() => {
    if (validateRequired(declarationRequest?.taxpayer?.commercial_register)) {
      if (
        !validateRequired(
          declarationRequest?.taxpayer?.commercial_register_attachment
            ?.full_url,
        )
      ) {
        setError(
          "commercial_register_attachment",
          "يجب رفع صورة رقم السجل التجاري",
        );
      } else {
        setError("commercial_register_attachment", "");
      }
    }
  }, [declarationRequest?.taxpayer?.commercial_register]);

  useEffect(() => {
    if (validateRequired(declarationRequest?.taxpayer?.tax_card_number)) {
      if (
        !validateRequired(
          declarationRequest?.taxpayer?.tax_card_attachment?.full_url,
        )
      ) {
        setError("tax_card_attachment", "يجب رفع صورة البطاقة الضريبية");
      } else {
        setError("tax_card_attachment", "");
      }
    }
  }, [declarationRequest?.taxpayer?.tax_card_number]);

  useEffect(() => {
    if (validateRequired(declarationRequest?.taxpayer?.other_attachment_name)) {
      if (
        !validateRequired(
          declarationRequest?.taxpayer?.other_attachment?.full_url,
        )
      ) {
        setError("other_attachment", "يجب رفع المرفق");
      } else {
        setError("other_attachment", "");
      }
    }
  }, [declarationRequest?.taxpayer?.other_attachment_name]);

  useEffect(() => {
    const currentNationality = declarationRequest?.taxpayer?.nationality_id;
    const hasNationality =
      currentNationality !== null &&
      currentNationality !== undefined &&
      currentNationality !== "";

    if (
      !hasNationality &&
      Array.isArray(nationalitesOptions) &&
      nationalitesOptions.length > 0
    ) {
      const firstNationalityId =
        nationalitesOptions[0]?.value ?? nationalitesOptions[0]?.id;

      if (firstNationalityId !== null && firstNationalityId !== undefined) {
        updateDeclarationTaxpayer("nationality_id", firstNationalityId);
        // handleNationalityChange();
      }
    }
  }, [nationalitesOptions, declarationRequest?.taxpayer?.nationality_id]);

  return (
    <div className={`${stylesRequestData.box} box pdf-box`}>
      <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
        بيانات المكلف بأداء الضريبة{" "}
      </h4>
      {unitOwnerTypeErrorMessage !== "" && (
        <div>
          <p className="alert alert-danger text-end mt-3">
            {unitOwnerTypeErrorMessage}
          </p>
        </div>
      )}

      <div className="row">
        {[5, 6, 7].includes(
          parseInt(declarationRequest?.applicant_role_id),
        ) && (
          <>
            <div className="col-md-4">
              <SearchSelectElement
                mb4="mb-4"
                labelHtmlFor="type_id"
                labelClassName={`required form-label ${stylesRequestData["form-label"]}`}
                labelText="نوع المكلف بأداء الضريبة"
                selectClassName={`${stylesRequestData["form-select"]} form-select`}
                selectID="type_id_input"
                name="type_id"
                options={generateOptions(taxpayerTypes)}
                default="أختار نوع المكلف بأداء الضريبة.."
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                key={parseInt(declarationRequest?.taxpayer?.type_id)}
                value={parseInt(declarationRequest?.taxpayer?.type_id)}
                onChange={handleChangeTaxPayer}
                pText={error_new_user.type_id}
                isClearable={true}
                disabled={declarationRequest?.viewMode}
              />
            </div>
          </>
        )}

        {parseInt(declarationRequest?.applicant_role_id) === 2 && (
          <>
            <div className="col-md-4">
              <div className={`${stylesRequestData["input-wrapper"]} `}>
                <span className={`${stylesRequestData["input-tag"]}`}>
                  ورثه/شركاء
                </span>

                <InputElement
                  value={declarationRequest?.taxpayer?.name || ""}
                  disabled={declarationRequest?.viewMode}
                  name="name"
                  onChange={handleChangeTaxPayer}
                  mb4="mb-4"
                  labelHtmlFor="name"
                  labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                  labelText="اسم المكلف بأداء الضريبة"
                  inputType="text"
                  inputClassName={`${stylesRequestData["form-control"]} ${stylesRequestData["pe-6"]}  form-control`}
                  inputID="name_input"
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={error_new_user.name}
                  allowedPattern={
                    /^(?!.*\p{P})(?:[A-Za-z\s]+|[\u0600-\u06FF\s]+)$/u
                  }
                  maxLength={100}
                />
              </div>
            </div>
            <div className="col-md-4">
              <SearchSelectElement
                mb4="mb-4"
                labelHtmlFor="nationality_id"
                labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                labelText="الجنسية"
                selectClassName={`${stylesRequestData["form-select"]} form-select`}
                selectID="nationality_id"
                inputId="nationality_code_input"
                name="nationality_id"
                options={nationalitesOptions}
                default="أختار الجنسية.."
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                pText={error_new_user.nationality_id}
                value={parseInt(declarationRequest?.taxpayer?.nationality_id)}
                onChange={handleChangeTaxPayer}
                isClearable={true}
                type="string"
                disabled={declarationRequest?.viewMode}
              />
            </div>
            <>
              {declarationRequest?.taxpayer?.nationality_id && (
                <>
                  {parseInt(declarationRequest?.taxpayer?.nationality_id) ===
                  63 ? (
                    <Fragment>
                      <div className="col-md-4 col-sm-6">
                        <InputElement
                          name="national_id"
                          mb4="mb-4"
                          labelHtmlFor="national_id"
                          labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                          labelText=" الرقم القومي"
                          inputType="text"
                          inputClassName={`${stylesRequestData["form-control"]} form-control`}
                          inputID="national_id_input"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          pText={error_new_user.national_id}
                          value={
                            declarationRequest?.taxpayer?.national_id || ""
                          }
                          onChange={handleChangeTaxPayer}
                          allowedPattern={/^\d+$/}
                          max={999999999999}
                          maxLength={14}
                          disabled={declarationRequest?.viewMode}
                        />
                      </div>
                      {!declarationRequest?.viewMode && (
                        <>
                          <div className="col-md-4 col-sm-6">
                            <InputElement
                              fileInputRef={nationalIdFileInputRef}
                              mb4="mb-4"
                              inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                              labelHtmlFor="national_id_attachment"
                              labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                              labelText="مرفق الرقم القومي"
                              inputType="file"
                              inputClassName={` ${stylesRequestData["form-control"]} form-control ${stylesRequestData["fileCustom"]}`}
                              inputID="national_id_attachment_input"
                              name="national_id_attachment"
                              fileName={
                                declarationRequest?.taxpayer
                                  ?.national_id_attachment
                                  ?.original_file_name || "إرفاق ملف"
                              }
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              icon="fa-solid fa-cloud-arrow-up"
                              accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                              pText={error_new_user.national_id_attachment}
                              onChange={handleChangeTaxPayerFile}
                              disabled={declarationRequest?.viewMode}
                              deleteFunction={() => {
                                handleChangeTaxPayer(
                                  "",
                                  "",
                                  "national_id_attachment",
                                  null,
                                );
                                if (nationalIdFileInputRef?.current) {
                                  nationalIdFileInputRef.current.value = null;
                                }

                                setError(
                                  "national_id_attachment",
                                  "يجب رفع مرفق الرقم القومي",
                                );
                              }}
                            />
                          </div>
                        </>
                      )}
                    </Fragment>
                  ) : parseInt(declarationRequest?.taxpayer?.nationality_id) !==
                      63 &&
                    declarationRequest?.taxpayer?.nationality_id !== "" ? (
                    <Fragment>
                      <div className="col-md-4 col-sm-6">
                        <InputElement
                          name="passport_number"
                          mb4="mb-4"
                          labelHtmlFor="passport_number"
                          labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                          labelText="رقم جواز السفر"
                          inputType="text"
                          inputClassName={`${stylesRequestData["form-control"]} form-control`}
                          inputID="passport_input"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          pText={error_new_user.passport_number}
                          value={
                            declarationRequest?.taxpayer?.passport_number || ""
                          }
                          onChange={handleChangeTaxPayer}
                          maxLength={24}
                          allowedPattern={/^[A-Za-z0-9\-\/]+$/}
                          disabled={declarationRequest?.viewMode}
                        />
                      </div>
                      {!declarationRequest?.viewMode && (
                        <>
                          <div className="col-md-4 col-sm-6">
                            <InputElement
                              fileInputRef={passportNumFileInputRef}
                              mb4="mb-4"
                              inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                              labelHtmlFor="passport_attachment"
                              labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                              labelText="مرفق جواز السفر"
                              inputType="file"
                              inputClassName={`${stylesRequestData["form-control"]} form-control`}
                              inputID="passport_attachment_input"
                              name="passport_attachment"
                              fileName={
                                declarationRequest?.taxpayer
                                  ?.passport_attachment?.original_file_name ||
                                "إرفاق ملف"
                              }
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              icon="fa-solid fa-cloud-arrow-up"
                              accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                              pText={error_new_user.passport_attachment}
                              onChange={handleChangeTaxPayerFile}
                              disabled={declarationRequest?.viewMode}
                              deleteFunction={() => {
                                handleChangeTaxPayer(
                                  "",
                                  "",
                                  "passport_attachment",
                                  null,
                                );
                                if (passportNumFileInputRef?.current) {
                                  passportNumFileInputRef.current.value = null;
                                }

                                setError(
                                  "passport_attachment",
                                  "يجب رفع مرفق جواز السفر",
                                );
                              }}
                            />
                          </div>
                        </>
                      )}
                    </Fragment>
                  ) : (
                    <Fragment></Fragment>
                  )}
                </>
              )}
            </>
          </>
        )}

        {declarationRequest?.taxpayer?.type_id && (
          <>
            {parseInt(declarationRequest?.taxpayer?.type_id) === 1 && (
              <Fragment>
                {[5, 6, 7].includes(
                  parseInt(declarationRequest?.applicant_role_id),
                ) && (
                  <>
                    <div className="col-md-4">
                      <InputElement
                        value={declarationRequest?.taxpayer?.first_name || ""}
                        disabled={declarationRequest?.viewMode}
                        name="first_name"
                        onChange={handleChangeTaxPayer}
                        mb4="mb-4"
                        labelHtmlFor="first_name"
                        labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                        labelText="الإسم الأول للمكلف بأداء الضريبة"
                        inputType="text"
                        inputClassName={`${stylesRequestData["form-control"]} form-control`}
                        inputID="unit_owner_type_first_name_input"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        pText={error_new_user.first_name}
                        allowedPattern={
                          /^(?!.*\p{P})(?:[A-Za-z]+(?:\s[A-Za-z]*)?|[\u0600-\u06FF]+(?:\s[\u0600-\u06FF]*)?|)$/u
                        }
                        maxLength={24}
                      />
                    </div>
                    <div className="col-md-4">
                      <InputElement
                        value={declarationRequest?.taxpayer?.last_name || ""}
                        disabled={declarationRequest?.viewMode}
                        name="last_name"
                        mb4="mb-4"
                        labelHtmlFor="last_name"
                        labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                        labelText="باقي الإسم للمكلف بأداء الضريبة"
                        inputType="text"
                        inputClassName={`${stylesRequestData["form-control"]} form-control`}
                        inputID="unit_owner_type_rest_name_input"
                        onChange={handleChangeTaxPayer}
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        allowedPattern={
                          /^(?!.*\p{P})(?:[A-Za-z\s]+|[\u0600-\u06FF\s]+)$/u
                        }
                        maxLength={64}
                        pText={error_new_user.last_name}
                      />
                    </div>
                    <div className="col-md-4">
                      <SearchSelectElement
                        mb4="mb-4"
                        labelHtmlFor="nationality_id"
                        labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                        labelText="الجنسية"
                        selectClassName={`${stylesRequestData["form-select"]} form-select`}
                        selectID="nationality_id"
                        inputId="nationality_code_input"
                        name="nationality_id"
                        options={nationalitesOptions}
                        default="أختار الجنسية.."
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        pText={error_new_user.nationality_id}
                        value={parseInt(
                          declarationRequest?.taxpayer?.nationality_id,
                        )}
                        onChange={handleChangeTaxPayer}
                        isClearable={true}
                        type="string"
                        disabled={declarationRequest?.viewMode}
                      />
                    </div>
                    <>
                      {declarationRequest?.taxpayer?.nationality_id && (
                        <>
                          {parseInt(
                            declarationRequest?.taxpayer?.nationality_id,
                          ) === 63 ? (
                            <Fragment>
                              <div className="col-md-4 col-sm-6">
                                <InputElement
                                  name="national_id"
                                  mb4="mb-4"
                                  labelHtmlFor="national_id"
                                  labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                                  labelText=" الرقم القومي"
                                  inputType="text"
                                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                                  inputID="national_id_input"
                                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                  pText={error_new_user.national_id}
                                  value={
                                    declarationRequest?.taxpayer?.national_id ||
                                    ""
                                  }
                                  onChange={handleChangeTaxPayer}
                                  allowedPattern={/^\d+$/}
                                  max={999999999999}
                                  maxLength={14}
                                  disabled={declarationRequest?.viewMode}
                                />
                              </div>
                              {!declarationRequest?.viewMode && (
                                <>
                                  <div className="col-md-4 col-sm-6">
                                    <InputElement
                                      fileInputRef={nationalIdFileInputRef}
                                      mb4="mb-4"
                                      inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                                      labelHtmlFor="national_id_attachment"
                                      labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                                      labelText="مرفق الرقم القومي"
                                      inputType="file"
                                      inputClassName={` ${stylesRequestData["form-control"]} form-control ${stylesRequestData["fileCustom"]}`}
                                      inputID="national_id_attachment_input"
                                      name="national_id_attachment"
                                      fileName={
                                        declarationRequest?.taxpayer
                                          ?.national_id_attachment
                                          ?.original_file_name || "إرفاق ملف"
                                      }
                                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                      icon="fa-solid fa-cloud-arrow-up"
                                      accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                                      pText={
                                        error_new_user.national_id_attachment
                                      }
                                      onChange={handleChangeTaxPayerFile}
                                      disabled={declarationRequest?.viewMode}
                                      deleteFunction={() => {
                                        handleChangeTaxPayer(
                                          "",
                                          "",
                                          "national_id_attachment",
                                          null,
                                        );
                                        if (nationalIdFileInputRef?.current) {
                                          nationalIdFileInputRef.current.value =
                                            null;
                                        }

                                        setError(
                                          "national_id_attachment",
                                          "يجب رفع مرفق الرقم القومي",
                                        );
                                      }}
                                    />
                                  </div>
                                </>
                              )}
                            </Fragment>
                          ) : parseInt(
                              declarationRequest?.taxpayer?.nationality_id,
                            ) !== 63 &&
                            declarationRequest?.taxpayer?.nationality_id !==
                              "" ? (
                            <Fragment>
                              <div className="col-md-4 col-sm-6">
                                <InputElement
                                  name="passport_number"
                                  mb4="mb-4"
                                  labelHtmlFor="passport_number"
                                  labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                                  labelText="رقم جواز السفر"
                                  inputType="text"
                                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                                  inputID="passport_input"
                                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                  pText={error_new_user.passport_number}
                                  value={
                                    declarationRequest?.taxpayer
                                      ?.passport_number || ""
                                  }
                                  onChange={handleChangeTaxPayer}
                                  maxLength={24}
                                  allowedPattern={/^[A-Za-z0-9\-\/]+$/}
                                  disabled={declarationRequest?.viewMode}
                                />
                              </div>
                              {!declarationRequest?.viewMode && (
                                <>
                                  {" "}
                                  <div className="col-md-4 col-sm-6">
                                    <InputElement
                                      fileInputRef={passportNumFileInputRef}
                                      mb4="mb-4"
                                      inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                                      labelHtmlFor="passport_attachment"
                                      labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                                      labelText="مرفق جواز السفر"
                                      inputType="file"
                                      inputClassName={`${stylesRequestData["form-control"]} form-control`}
                                      inputID="passport_attachment_input"
                                      name="passport_attachment"
                                      fileName={
                                        declarationRequest?.taxpayer
                                          ?.passport_attachment
                                          ?.original_file_name || "إرفاق ملف"
                                      }
                                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                      icon="fa-solid fa-cloud-arrow-up"
                                      accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                                      pText={error_new_user.passport_attachment}
                                      onChange={handleChangeTaxPayerFile}
                                      disabled={declarationRequest?.viewMode}
                                      deleteFunction={() => {
                                        handleChangeTaxPayer(
                                          "",
                                          "",
                                          "passport_attachment",
                                          null,
                                        );
                                        if (passportNumFileInputRef?.current) {
                                          passportNumFileInputRef.current.value =
                                            null;
                                        }

                                        setError(
                                          "passport_attachment",
                                          "يجب رفع مرفق جواز السفر",
                                        );
                                      }}
                                    />
                                  </div>
                                </>
                              )}
                            </Fragment>
                          ) : (
                            <Fragment></Fragment>
                          )}
                        </>
                      )}
                    </>
                  </>
                )}
              </Fragment>
            )}

            {parseInt(declarationRequest?.taxpayer?.type_id) === 2 &&
              [5, 6, 7].includes(
                parseInt(declarationRequest?.applicant_role_id),
              ) && (
                <Fragment>
                  <div className="col-md-4">
                    <InputElement
                      value={declarationRequest?.taxpayer?.name || ""}
                      name="name"
                      onChange={handleChangeTaxPayer}
                      mb4="mb-4"
                      labelHtmlFor="name"
                      labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                      labelText="اسم المكلف بأداء الضريبة"
                      inputType="text"
                      inputClassName={`${stylesRequestData["form-control"]} form-control`}
                      inputID="name_input"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      pText={error_new_user.name}
                      allowedPattern={
                        /^(?!.*\p{P})(?:[A-Za-z\s]+|[\u0600-\u06FF\s]+)$/u
                      }
                      maxLength={100}
                      disabled={declarationRequest?.viewMode}
                    />
                  </div>
                  <div className="col-md-4">
                    <InputElement
                      name="commercial_register"
                      mb4="mb-4"
                      labelHtmlFor="commercial_register"
                      labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                      labelText="رقم السجل التجاري"
                      inputType="text"
                      inputClassName={`${stylesRequestData["form-control"]} form-control`}
                      inputID="commercial_register_input"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      pText={error_new_user.commercial_register}
                      value={
                        declarationRequest?.taxpayer?.commercial_register || ""
                      }
                      onChange={handleChangeTaxPayer}
                      allowedPattern={/^\d+$/}
                      maxLength={100}
                      disabled={declarationRequest?.viewMode}
                    />
                  </div>

                  {!declarationRequest?.viewMode && (
                    <>
                      <div className="col-md-4 col-sm-6">
                        <InputElement
                          fileInputRef={commercialRegistrationNumberInputRef}
                          dimDisabled
                          mb4="mb-4"
                          inputIcon={` ${stylesRequestData["input-icon"]} input-icon`}
                          labelHtmlFor="commercial_register_attachment"
                          labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                          labelText="صورة رقم السجل التجاري"
                          inputType="file"
                          inputClassName={`${stylesRequestData["form-control"]} form-control ${stylesRequestData["fileCustom"]}`}
                          inputID="commercial_register_file_input"
                          name="commercial_register_attachment"
                          fileName={
                            declarationRequest?.taxpayer
                              ?.commercial_register_attachment
                              ?.original_file_name || "إرفاق ملف"
                          }
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          icon="fa-solid fa-cloud-arrow-up"
                          accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                          pText={error_new_user.commercial_register_attachment}
                          onChange={handleChangeTaxPayerFile}
                          hasDeleteButton={validateRequired(
                            declarationRequest?.taxpayer?.commercial_register,
                          )}
                          disabled={
                            !validateRequired(
                              declarationRequest?.taxpayer?.commercial_register,
                            ) || declarationRequest?.viewMode
                          }
                          deleteFunction={() => {
                            handleChangeTaxPayer(
                              "",
                              "",
                              "commercial_register_attachment",
                              null,
                            );
                            if (commercialRegistrationNumberInputRef?.current) {
                              commercialRegistrationNumberInputRef.current.value =
                                null;
                            }

                            setError(
                              "commercial_register_attachment",
                              "يجب رفع صورة السجل التجاري",
                            );
                          }}
                        />
                      </div>
                    </>
                  )}

                  <div className="col-md-4">
                    <InputElement
                      name="tax_card_number"
                      mb4="mb-4"
                      labelHtmlFor="tax_card_number"
                      labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                      labelText="رقم البطاقة الضريبية"
                      inputType="text"
                      inputClassName={`${stylesRequestData["form-control"]} form-control`}
                      inputID="tax_card_number_input"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      pText={error_new_user.tax_card_number}
                      value={
                        declarationRequest?.taxpayer?.tax_card_number || ""
                      }
                      onChange={handleChangeTaxPayer}
                      allowedPattern={/^\d+$/}
                      maxLength={100}
                      disabled={declarationRequest?.viewMode}
                    />
                  </div>
                  {!declarationRequest?.viewMode && (
                    <>
                      {" "}
                      <div className="col-md-4 col-sm-6">
                        <InputElement
                          fileInputRef={taxNumberFileInputRef}
                          dimDisabled
                          mb4="mb-4"
                          inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                          labelHtmlFor="tax_card_attachment"
                          labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                          labelText="صورة البطاقة الضريبية"
                          inputType="file"
                          inputClassName={`${stylesRequestData["form-control"]} form-control ${stylesRequestData["fileCustom"]}`}
                          inputID="tax_card_number_file_input"
                          name="tax_card_attachment"
                          fileName={
                            declarationRequest?.taxpayer?.tax_card_attachment
                              ?.original_file_name || "إرفاق ملف"
                          }
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          icon="fa-solid fa-cloud-arrow-up"
                          accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                          pText={error_new_user.tax_card_attachment}
                          onChange={handleChangeTaxPayerFile}
                          hasDeleteButton={validateRequired(
                            declarationRequest?.taxpayer?.tax_card_number,
                          )}
                          disabled={
                            !validateRequired(
                              declarationRequest?.taxpayer?.tax_card_number,
                            ) || declarationRequest?.viewMode
                          }
                          deleteFunction={() => {
                            handleChangeTaxPayer(
                              "",
                              "",
                              "tax_card_attachment",
                              null,
                            );
                            if (taxNumberFileInputRef?.current) {
                              taxNumberFileInputRef.current.value = null;
                            }
                            setError(
                              "tax_card_attachment",
                              "يجب رفع صورة البطاقة الضريبية",
                            );
                          }}
                        />
                      </div>
                    </>
                  )}

                  <div className="col-md-4">
                    <InputElement
                      name="other_attachment_name"
                      mb4="mb-4"
                      labelHtmlFor="other_attachment_name"
                      labelClassName={`${
                        validateRequired(
                          declarationRequest?.taxpayer?.other_attachment
                            ?.full_url,
                        ) && "required"
                      } ${stylesRequestData["form-label"]} form-label`}
                      labelText="اسم المرفق الآخر"
                      inputType="text"
                      inputClassName={`${stylesRequestData["form-control"]} form-control`}
                      inputID="unit_owner_other_input"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      pText={error_new_user.other_attachment_name}
                      value={
                        declarationRequest?.taxpayer?.other_attachment_name ||
                        ""
                      }
                      onChange={handleChangeTaxPayer}
                      allowedPattern={
                        /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
                      }
                      maxLength={100}
                      disabled={declarationRequest?.viewMode}
                    />
                  </div>

                  {!declarationRequest?.viewMode && (
                    <>
                      {" "}
                      <div className="col-md-4 col-sm-6">
                        <InputElement
                          fileInputRef={otherEntityFileInputRef}
                          dimDisabled
                          mb4="mb-4"
                          inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                          labelHtmlFor="other_attachment"
                          labelClassName={`${
                            validateRequired(
                              declarationRequest?.taxpayer
                                ?.other_attachment_name,
                            ) && "required"
                          } ${stylesRequestData["form-label"]} form-label`}
                          labelText="المرفق"
                          inputType="file"
                          inputClassName={`${stylesRequestData["form-control"]} form-control ${stylesRequestData["fileCustom"]}`}
                          inputID="other_entity_file_input"
                          name="other_attachment"
                          fileName={
                            declarationRequest?.taxpayer?.other_attachment
                              ?.original_file_name || "إرفاق ملف"
                          }
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          pText={error_new_user.other_attachment}
                          icon="fa-solid fa-cloud-arrow-up"
                          accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                          onChange={handleChangeTaxPayerFile}
                          hasDeleteButton={validateRequired(
                            declarationRequest?.taxpayer?.other_attachment_name,
                          )}
                          disabled={
                            !validateRequired(
                              declarationRequest?.taxpayer
                                ?.other_attachment_name,
                            ) || declarationRequest?.viewMode
                          }
                          deleteFunction={() => {
                            handleChangeTaxPayer(
                              "",
                              "",
                              "other_attachment",
                              null,
                            );
                            if (otherEntityFileInputRef?.current) {
                              otherEntityFileInputRef.current.value = null;
                            }
                            setError("other_attachment", "يجب رفع المرفق");
                          }}
                        />
                      </div>
                    </>
                  )}
                </Fragment>
              )}
          </>
        )}

        {/* TODO handle the phone, email required case for both types in the submit validation */}

        {[5, 6, 7].includes(
          parseInt(declarationRequest?.applicant_role_id),
        ) && (
          <>
            {" "}
            <div className="col-md-4">
              {/* <InputElement
                value={declarationRequest?.taxpayer?.phone || ""}
                disabled={declarationRequest?.viewMode}
                name="phone"
                onChange={handleChangeTaxPayer}
                mb4="mb-4"
                labelHtmlFor="phone"
                labelClassName={`${parseInt(declarationRequest?.taxpayer?.type_id) === 1 ? "required" : ""} ${stylesRequestData["form-label"]} form-label`}
                labelText="رقم الهاتف المحمول"
                inputType="text"
                inputClassName={`${stylesRequestData["form-control"]} }  form-control`}
                inputID="phone_input"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                pText={error_new_user.phone}
                allowedPattern={/^(?:|0|01|01(?:0|1|2|5)\d{0,8})$/}
                maxLength={11}
              /> */}{" "}
              <div className="mb-4">
                <label
                  htmlFor="phone"
                  className={`${parseInt(declarationRequest?.taxpayer?.type_id) === 1 && "required"} ${stylesRequestData["form-label"]} form-label`}
                >
                  رقم الهاتف المحمول
                </label>

                <PhoneInput
                  country={declarationRequest?.taxpayer?.country_code || "eg"} // default Egypt
                  preferredCountries={[
                    "eg",
                    "sa",
                    "ae",
                    "jo",
                    "kw",
                    "qa",
                    "bh",
                    "om",
                    "ma",
                  ]}
                  value={declarationRequest?.taxpayer?.phone}
                  onChange={(value, country, e, formattedValue) => {
                    // If the selected country changed, reset phone_number
                    if (
                      country?.countryCode !==
                      declarationRequest?.taxpayer?.country_code
                    ) {
                      value = country.dialCode;
                    }

                    const nationalNumber = value
                      .replace(country.dialCode, "")
                      .replace(/\D/g, "");

                    // ✅ Egypt-specific normalization: remove extra leading 0
                    if (
                      country?.countryCode === "eg" &&
                      nationalNumber.startsWith("0")
                    ) {
                      value = country.dialCode + nationalNumber.slice(1);
                    }

                    // ✅ Length validation, but don’t wipe the value
                    if (
                      (nationalNumber?.length < 6 ||
                        nationalNumber?.length > 15) &&
                      value !== country?.dialCode
                    ) {
                      setPhoneError(
                        "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول وفقا للدولة المختارة",
                      );
                      // keep the current value instead of returning
                      handleChangeTaxPayer("", "", "phone", value);
                    } else {
                      setPhoneError(null);
                      handleChangeTaxPayer("", "", "phone", value);
                    }

                    handleChangeTaxPayer(
                      "",
                      "",
                      "country_code",
                      country?.countryCode,
                    );
                    handleChangeTaxPayer(
                      "",
                      "",
                      "dial_code",
                      country?.dialCode,
                    );
                  }}
                  inputProps={{
                    name: "phone",
                    id: "phone",
                    required: true,
                    className: "phone-control form-control",
                    placeholder: "",
                  }}
                  containerClass="w-100"
                  inputClass="w-100"
                  enableAreaCodes={false}
                  countryCodeEditable={false}
                  enableSearch={true}
                  disabled={declarationRequest?.viewMode}
                />

                {(phoneError || error_new_user.phone) &&
                  !declarationRequest?.viewMode && (
                    <p className="text-danger mb-0 mt-2 me-2 fw-bolder">
                      {phoneError || error_new_user.phone}
                    </p>
                  )}
              </div>
            </div>
            <div className="col-md-4">
              <InputElement
                mb4="mb-4"
                name="email"
                labelHtmlFor="email"
                labelClassName={` ${stylesRequestData["form-label"]} form-label`}
                labelText="البريد الإلكترونى"
                inputType="email"
                inputClassName={`${stylesRequestData["form-control"]}}  form-control`}
                inputID="email"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={declarationRequest?.taxpayer?.email || ""}
                onChange={handleChangeTaxPayer}
                pText={error_new_user.email}
                disabled={declarationRequest?.viewMode}
                allowedPattern={/^(?=.{0,100}$)[A-Za-z0-9@._-]*$/}
                maxLength={100}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TaxPayerForm;
